export var TileType;
(function (TileType) {
    TileType["PAYMENT"] = "PAYMENT";
    TileType["DOCUMENT"] = "DOCUMENT";
    TileType["IDENTITY"] = "IDENTITY";
})(TileType || (TileType = {}));
export var VerificationType;
(function (VerificationType) {
    VerificationType["DOCUMENT"] = "DOCUMENT";
    VerificationType["IDENTITY"] = "IDENTITY";
})(VerificationType || (VerificationType = {}));
export var DocumentStatus;
(function (DocumentStatus) {
    DocumentStatus["VERIFIED"] = "VERIFIED";
    DocumentStatus["REJECTED"] = "REJECTED";
    DocumentStatus["PENDING"] = "PENDING";
    DocumentStatus["REQUIRED"] = "REQUIRED";
    DocumentStatus["SUBMITTED"] = "SUBMITTED";
    DocumentStatus["NOT_UPLOADED"] = "NOT_UPLOADED";
})(DocumentStatus || (DocumentStatus = {}));
//# sourceMappingURL=types.js.map